import { AttributeTypeValue, ParamTypeValue } from "@bonusmap/api-types";
const defs = {
    number: 'Numero',
    boolean: 'Booleano',
    date: 'Data',
    range_number: 'Intervallo numerico',
    range_date: 'Intervallo di date',
    number_array: 'Lista di numeri',
    date_array: 'Lista di date'
}
const valids: Record<AttributeTypeValue, ParamTypeValue[]> = {
    "boolean": [
        "boolean"
    ],
    "date": [
        "date", "date_array", "range_date"
    ],
    "number": [
        "number", "number_array", "range_number"
    ]
}
// controlla validità di un attributo assegnato a un parametro
export function paramAttributeCheckValidity(
    attributeTypeValue: AttributeTypeValue,
    parameterTypeValue: ParamTypeValue
):boolean {
    const isValid = valids[attributeTypeValue].includes(parameterTypeValue);
    return isValid;
}
export function paramAttributeReportValidity(
    attributeTypeValue: AttributeTypeValue,
    parameterTypeValue: ParamTypeValue):string {
        if(!paramAttributeCheckValidity(attributeTypeValue,parameterTypeValue)) {
            return `Un tipo di attributo che ha valori di tipo ${defs[attributeTypeValue]} non può essere assegnato a un parametro che ha valori di tipo ${defs[parameterTypeValue]}`;
        }
        return "";
    }